<template>
  <div class="input-field mb-0 !max-w-none relative flex items-center">
    <FontAwesomeIcon
      :icon="faMagnifyingGlass"
      class="absolute left-3 text-lg text-chrome-dark"
    />

    <input
      v-model="model"
      type="text"
      :placeholder="placeholder"
      class="!mb-0 lg:min-w-72 xl:min-w-96 !pl-8"
    >

    <div
      v-if="model"
      class="absolute right-3 flex items-center"
    >
      <AppTooltip>
        <template #reference>
          <button
            type="button"
            class="text-primary hover:text-secondary cursor-pointer leading-[1]"
            @click="clearInput"
          >
            <FontAwesomeIcon :icon="faUndo" />
          </button>
        </template>

        Clear search
      </AppTooltip>
    </div>
  </div>
</template>

<script setup>
import { faMagnifyingGlass, faUndo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { AppTooltip } from '@/components/app';

defineProps({
  placeholder: {
    type: String,
    default: 'Search Query',
  },
});

const emit = defineEmits(['clear']);

const model = defineModel();

function clearInput() {
  model.value = null;
  emit('clear');
}
</script>
